<template>
    <v-card>
        <div v-bind:style="{ display: showDeviceList(), padding: '3px', backgroundColor: '#fff' }">
            <table>
                <tr>
                    <td>Keyword Index</td>
                    <td><input type="number" v-model="voiceCommandTestKeywordIndex"></td>
                </tr>
                <tr>
                    <td>A/I</td>
                    <td>
                        <select id="audioSource" @change="init();" ></select>
                    </td>
                    <td>A/O</td>
                    <td><select id="audioOutput" @change="changeAudioDestination();"></select></td>
                </tr>
                <tr>
                    <td>V/I</td>
                    <td><select id="videoSource" @change="init();" ></select></td>
                    <td>WebSocket</td>
                    <td>
                        <select v-model="openWebsocketMode" @change="init();">
                            <option value="0">Disable</option>
                            <option value="1">Enable</option>
                        </select>
                    </td>
                </tr>
                <!--<tr>
                    <td colspan="4">
                        <div id="d" v-for="i in 256">
                            <div></div>
                        </div>
                    </td>
                </tr>-->
            </table>
            <audio id='speak' :src="require(`@/assets/speak.wav`)" crossorigin="anonymous"></audio>
            <audio id='photo' :src="require(`@/assets/photo.mp3`)" crossorigin="anonymous"></audio>
        </div>
        <div id="monitor" class="monitor">
            <canvas id="showVideo" style="display:none;"></canvas>
            <video id="camera" autoplay playsinline></video>
            <!--<video id="camera" :src="require(`@/assets/Colonscopy_demo_film_v04.mp4`)" autoplay playsinline></video>-->
        </div>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "Video",
    props: {
        speechRecognition: {
            type: Function,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getUser'
        ]),
        ...mapGetters('examinations', [
            'getExaminationData',
            'getVoiceCommandTestKeyword',
            'getStoreHiddenParameter'
        ]),
        examination_typeID() {
            return this.getExaminationData.examination.examination_typeID
        },

        examinationID() {
            return this.getExaminationData.examination.id
        },

        accNo() {
            return this.getExaminationData.examination.accNo
        },
    },
    data() {
        return {
            // webRTCStreaming: false,
            video: '',
            canvas: '',
            constraints: '',
            audioContext: '',
            recorder: '',
            // recordTask: null,
            recording: false,
            startTimestamp: 0,
            endTimestamp: 0,
            keydownTime: 0,
            voiceCommandTestKeywordIndex: 0,
            keywordFileType: ["Examination", "Script", "Free"],
            keywordFile: 0,
            runTest: true,
            websocketOnOpenInterval: null,
            openWebsocketMode: 2,// true: open Websocket Mode, false: open File Mode。2: new AI MODEL(Alim and Gray)
            tempWebsocketResult: {},
            dataArray: [],
            soundWaveInterval: null,
            todoAutoInputInterval: null,
            dd: null,
            //file1: 'dist/speak.wav',
            isDestroyed: false,
        }
    },
    methods: {
        ...mapActions('examinations', [
            'fetchVoiceCommandTestKeywordArray',
            'setRecording',
            'setJudging',
            'setTimeCounting',
            'toggleWebrtcStatus'
        ]),
        async init() {
            // this.dd = document.querySelectorAll('#d div');
            var clientWidth = Number(document.body.clientWidth);
            var clientHeight = Number(document.body.clientHeight);
            var temp_width = clientWidth / 10 * 6;
            var temp_height = (temp_width * 10000) / 17777;

            // 640*480
            var maxHeight = clientHeight / 100 * 60;
            temp_width = temp_width * (maxHeight / temp_height);
            temp_height = temp_height * (maxHeight / temp_height);

            this.video = document.querySelector('video');
            this.canvas = window.canvas = document.querySelector('#showVideo');

            if (window.stream) {
                window.stream.getTracks().forEach(track => {
                    track.stop();
                });
            }

            if (['', null].indexOf(this.video.src) != -1) {
                // ===============================================
                // Stream Start
                // ===============================================
                const audioSource = document.querySelector('select#audioSource').value;
                const videoSource = document.querySelector('select#videoSource').value;
                this.constraints = window.constraints = {
                    audio: {
                        deviceId: audioSource ? {
                            exact: audioSource
                        } : undefined
                    },
                    video: {
                        deviceId: videoSource ? {
                            exact: videoSource
                        } : undefined,
                        width: {
                            exact: temp_width
                        },
                        height: {
                            exact: temp_height
                        }
                    }
                };
                await navigator.mediaDevices.getUserMedia(this.constraints)
                    .then(this.handleSuccess)
                    .catch(this.handleError);
                // ===============================================
                // Stream End
                // ===============================================
            } else {
                // ===============================================
                // Video Start
                // ===============================================
                this.video.width = temp_width;
                this.video.height = temp_height;

                if (window.stream) {
                    window.stream.getTracks().forEach(track => {
                        track.stop();
                    });
                }
                const audioSource = document.querySelector('select#audioSource').value;
                this.constraints = window.constraints = {
                    audio: {
                        deviceId: audioSource ? {
                            exact: audioSource
                        } : undefined
                    }
                };
                await navigator.mediaDevices.getUserMedia(this.constraints)
                    .then(this.handleSuccess)
                    .catch(this.handleError);
                // ===============================================
                // Video End
                // ===============================================
            }
            const $camera = document.getElementById("camera")
            if ($camera) {
                $camera.volume = 0;
            }
        },
        handleError(error) {
            console.log('Error:' + error.name, error);
        },
        handleSuccess(stream) {
            this.stream = stream;
            window.stream = stream;
            if (['', null].indexOf(this.video.src) != -1) {
                this.video.srcObject = stream;
            }

            this.audioContext = new AudioContext({
                sampleRate: 16000
            }); //44000 -> 16000
            this.audioContext.destination.channelCount = 1;
            let input = this.audioContext.createMediaStreamSource(stream);

            // Firefox loses the audio input stream every five seconds
            // To fix added the input to window.source
            window.source = input;

            // make the analyser available in window context
            window.userSpeechAnalyser = this.audioContext.createAnalyser();
            input.connect(window.userSpeechAnalyser);
            // window.userSpeechAnalyser.connect(this.audioContext.destination);

            // window.userSpeechAnalyser.fftSize = 2048;
            // this.dataArray = new Uint8Array(window.userSpeechAnalyser.fftSize);

            this.recorder = new Recorder(input); // eslint-disable-line
            //==========================================================================
            //※ Keyboard even
            //==========================================================================
            const _this = this
            window.onkeydown = function(e) {
                var keyCode = e.keyCode ? e.keyCode : e.charCode;
                function getKeyCode(keyCode) {
                  return {
                    71: 'G',
                    72: 'H',
                    82: 'R',
                    83: 'S',
                    84: 'T',
                    86: 'V',
                    88: 'X',
                    90: 'Z',
                    67: 'C',
                  }[Number(keyCode)];
                }
                switch (getKeyCode(keyCode)) {
                    case 'V':
                      _this.toggleWebrtcStatus();
                      break;
                    case 'G':
                        if (_this.getUser != null && ['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                            _this.autoInput();
                        }
                        break;
                    case 'H':
                        if (_this.getUser != null && ['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                            _this.runTest = _this.runTest ? false : true;
                            console.log('# run: ' + _this.runTest);
                        }
                        break;
                    case 'S':
                        if (_this.getUser != null && ['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                            _this.keywordFile += 1;
                            if (_this.keywordFile == _this.keywordFileType.length) {
                                _this.keywordFile = 0;
                            }
                            _this.fetchVoiceCommandTestKeywordArray({
                                keywordFile: _this.keywordFile,
                                examination_typeID: _this.examination_typeID
                            });
                            _this.voiceCommandTestKeywordIndex = 0;
                            console.log('# Keyword File: ' + _this.keywordFileType[_this.keywordFile]);
                        }
                        break;
                    case 'R':
                        if (_this.getUser != null && ['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                            _this.fetchVoiceCommandTestKeywordArray({
                                keywordFile: _this.keywordFile,
                                examination_typeID: _this.examination_typeID
                            });
                            _this.voiceCommandTestKeywordIndex = 0;
                            console.log('# Reload: ' + _this.keywordFileType[_this.keywordFile]);
                        }
                        break;
                    case 'T':
                        if (_this.getUser != null && ['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                            console.log('# index: ' + _this.voiceCommandTestKeywordIndex);
                            console.log('# input: ' + _this.getVoiceCommandTestKeyword[_this.voiceCommandTestKeywordIndex]);
                            _this.speechRecognition(_this.getVoiceCommandTestKeyword[_this.voiceCommandTestKeywordIndex].toLowerCase(), 'test');
                            if (_this.voiceCommandTestKeywordIndex == (_this.getVoiceCommandTestKeyword.length - 1)) {
                                _this.voiceCommandTestKeywordIndex = 0;
                            } else {
                                _this.voiceCommandTestKeywordIndex = Number(_this.voiceCommandTestKeywordIndex) + 1;
                            }
                        }
                        break;
                    case 'X': 
                        // 觸發語音辨識
                        if (!_this.recording) {
                            let API_URL = process.env.VUE_APP_API_URL
                            let frontEndLog;
                            let url;
                            const options = {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            };
                            frontEndLog=new Date().getTime().toString();
                            console.log('onkeydown: ' + frontEndLog);
                            let params = JSON.stringify({
                                frontEndLog: 'onkeydown: ' + frontEndLog
                            })
                            url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                            _this.$http.post(url, params, options).then((response) => {
                                //console.log(response);
                            });
                            _this.recording = true;
                            _this.startRecording();
                            _this.musicPlay('speak');
                            _this.startTimestamp = (new Date()).getTime().toString();
                        }
                        break;
                    case 'Z':
                        _this.keydownTime += 1;
                        //if (_this.keydownTime > 2) {
                            // 觸發語音辨識
                        if (!_this.recording) {
                            let API_URL = process.env.VUE_APP_API_URL
                            let frontEndLog;
                            let url;
                            const options = {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            };
                            frontEndLog=new Date().getTime().toString();
                            console.log('onkeydown: ' +frontEndLog);
                            let params = JSON.stringify({
                                frontEndLog: 'onkeydown: ' + frontEndLog
                            })
                            url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                            _this.$http.post(url, params, options).then((response) => {
                                console.log(response);
                            });
                            _this.recording = true;
                            _this.startRecording();
                            _this.musicPlay('speak');
                            _this.startTimestamp = (new Date()).getTime().toString();
                        }
                        //}
                        break;
                }
            };
            window.onkeyup = function(e) {
                var keyCode = e.keyCode ? e.keyCode : e.charCode;
                const API_URL = process.env.VUE_APP_API_URL
                let frontEndLog;
                let url;
                const options = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                let params;
                switch (Number(keyCode)) {
                    case 88: // x 
                        console.log('onkeyup: ' + (new Date()).getTime().toString());
                        // 關閉語音辨識
                        frontEndLog=new Date().getTime().toString();
                        console.log('Stop Recording ' + frontEndLog);
                        params = JSON.stringify({
                                frontEndLog: 'Stop Recording ' + frontEndLog
                            })
                        url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                        _this.$http.post(url, params, options).then((response) => {
                            //console.log(response);
                        });
                        _this.recording = false;
                        _this.stopRecording();
                        _this.endTimestamp = (new Date()).getTime().toString();
                        break;
                    case 67:
                        _this.savePic();
                        _this.musicPlay('photo');
                        break;
                    case 90: // z 
                        console.log('onkeyup: ' + (new Date()).getTime().toString());
                        if (_this.keydownTime < 2) {
                            // 觸發拍照
                            _this.savePic();
                            _this.musicPlay('photo');
                        }
                        if (_this.recording) {
                            setTimeout(function() {
                                // 關閉語音辨識  
                                frontEndLog=new Date().getTime().toString();
                                console.log('Stop Recording ' + frontEndLog);
                                params = JSON.stringify({
                                    frontEndLog: 'Stop Recording ' + frontEndLog
                                })
                                url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                                _this.$http.post(url, params, options).then((response) => {
                                    console.log(response);
                                });
                                _this.recording = false;
                                _this.stopRecording('2');
                                _this.endTimestamp = (new Date()).getTime().toString();
                            }, 300);
                        }
                        _this.keydownTime = 0;
                        break;
                }
            };
            if (this.isDestroyed) {
                this.clearStram()
            }
        },
        attachSinkId(element, sinkId) {
            if (typeof element.sinkId !== 'undefined') {
                element.setSinkId(sinkId)
                    .then(() => {
                        console.log(`Success, audio output device attached: ${sinkId}`);
                    })
                    .catch(error => {
                        let errorMessage = error;
                        if (error.name === 'SecurityError') {
                            errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
                        }
                        console.error(errorMessage);
                        // Jump back to first output device in the list as it's the default.
                        document.querySelector('select#audioOutput').selectedIndex = 0;
                    });
            } else {
                console.warn('Browser does not support output device selection.');
            }
        },
        changeAudioDestination() {
            const audioDestination = document.querySelector('select#audioOutput').value;
            this.attachSinkId(this.video, audioDestination);
        },
        autoInput() {
            const _this = this;
            this.todoAutoInputInterval = setInterval(() => {
                _this.todoAutoInput();
            }, 100);
        },
        todoAutoInput() {
            if (this.runTest) {
                console.log('# index: ' + this.voiceCommandTestKeywordIndex + ' => ' + this.getVoiceCommandTestKeyword[this.voiceCommandTestKeywordIndex]);
                this.speechRecognition(this.getVoiceCommandTestKeyword[this.voiceCommandTestKeywordIndex].toLowerCase(), 'test');
                if (this.voiceCommandTestKeywordIndex == (this.getVoiceCommandTestKeyword.length - 1)) {
                    this.voiceCommandTestKeywordIndex = 0;
                    this.runTest = false
                } else {
                    this.voiceCommandTestKeywordIndex = Number(this.voiceCommandTestKeywordIndex) + 1;
                }
            }
        },
        savePic() {
            console.log("savePic #1: " + (new Date()).getTime().toString());

            const API_URL = process.env.VUE_APP_API_URL
            const eID = this.examinationID;
            const eAccNo = this.accNo;
            var fID = this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex] ? this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex].id : 0;
            if (this.getStoreHiddenParameter.over) {
                fID = 0;
            }
            const timestamp = (new Date()).getTime().toString();
            const url = `${API_URL}/saveImage/${eID}/${eAccNo}/${fID}?t=` + timestamp;
            if (this.video.videoWidth !== 0 && this.video.videoHeight !== 0) {
            // Small
            this.canvas.width = this.video.videoWidth / 4;
            this.canvas.height = this.video.videoHeight / 4;
            this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
            let tmpSmall = this.canvas

            let tmpSmallObj = {
                "id": timestamp,
                "examinationID": eID,
                "findingID": fID,
                "file": null,
                "landmarkID": 0,
                "cm": null,
                "status": "0",
                "timestamp": timestamp,
                "data": tmpSmall.toDataURL("image/jpeg")
            };
            this.$store.dispatch('examinations/addScreenshot', {
                data: tmpSmallObj,
                timestamp: null
            })

            // Original
            this.canvas.width = this.video.videoWidth;
            this.canvas.height = this.video.videoHeight;
            this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
            let tmp = this.canvas

            const params = JSON.stringify({
                data: tmp.toDataURL("image/jpeg")
            })
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            // console.log("savePic #3: " + (new Date()).getTime().toString());
            this.$http.post(url, params, options).then((response) => {
                // console.log("savePic #6: " + (new Date()).getTime().toString());
                // console.log(response.body.screenshot);
                this.$store.dispatch('examinations/addScreenshot', {
                    data: response.body.screenshot,
                    timestamp: timestamp
                })
                // console.log("savePic #7: " + (new Date()).getTime().toString());
                // alert('1 || ' + response.body.result);
                // alert('1 || ' + response.body.screenshot.id);
                // alert('1 || ' + response.body.screenshot.file);
            }, (response) => {
                // console.log(response);
                // alert('2 || ' + response.body.result);
                // alert('2 || ' + response.body.screenshot.id);
                // alert('2 || ' + response.body.screenshot.file);
            });
          }
        },
        startRecording() {
            this.setRecording(true);
            this.setJudging(true);
            // this.webRTCStreaming = true;
            let frontEndLog=new Date().getTime().toString();
            console.log('Recording ... ' + frontEndLog);
            let url;
            const API_URL = process.env.VUE_APP_API_URL
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            let params = JSON.stringify({
                        frontEndLog: 'Recording ... ' + frontEndLog
                    })
                    url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                    this.$http.post(url, params, options).then((response) => {
                        //console.log(response);
                    });
            this.recorder && this.recorder.record();
			
            const _this = this;

            /*this.soundWaveInterval = setInterval(function() {
                window.userSpeechAnalyser.getByteFrequencyData(_this.dataArray);
                for (let j = 0; j < 256; j++) {
                    _this.dd[j].style.height = (Number(_this.dataArray[j]) / 2) + 'px';
                    _this.dd[j].style.background = 'rgba(' + (255 - j) + ',' + j * 2 + ',0,1)';
                }
            }, 20);*/

            if (Number(this.openWebsocketMode) == 1 || Number(this.openWebsocketMode) == 2) {

                //==========================================================================
                //※ Websocket Mode
                //==========================================================================
                _this.$connect();

            }
        },
        stopRecording(indata) {
            this.setRecording(false);
            let JUDGING_TIMOUT = 3500;
            setTimeout(() => { this.setJudging(false) }, JUDGING_TIMOUT);
            /*clearInterval(this.soundWaveInterval);
            for (let j = 0; j < 256; j++) {
                this.dd[j].style.height = '0px';
                this.dd[j].style.background = 'rgba(' + (255 - j) + ',' + j * 2 + ',0,1)';
            }*/

            if (Number(this.openWebsocketMode) == 0) {

                //==========================================================================
                //※ WAV Mode
                //==========================================================================
                const _this = this;
                // this.webRTCStreaming = false;
                this.recorder && this.recorder.stop();
				
                this.recorder.exportWAV(function(blob) {
                    // var url = URL.createObjectURL(blob); // eslint-disable-line
                    // console.log(url);
                    var reader = new FileReader();
                    reader.onload = function(e) { // eslint-disable-line
                        var rawData = reader.result;
                        _this.speechRecognition(rawData, 'speak');
                    }
                    reader.readAsDataURL(blob); // blob -> base64
                });

                this.recorder.clear();
				
            } else {                
                //==========================================================================
                //※ Websocket Mode
                //==========================================================================
                const _this = this;
                clearInterval(this.websocketOnOpenInterval);		
				
                this.recorder && this.recorder.stop();
				
				if (Number(this.openWebsocketMode) == 2 && indata=='2')
				{
					_this.recorder.exportWAV(function(blob) {
						var reader = new FileReader();
						reader.onload = function(e) { // eslint-disable-line
							var rawData = reader.result;
							_this.speechRecognition(rawData, 'websocket2');															
						}
						reader.readAsDataURL(blob); // blob -> base64
					});
				}
				
                this.recorder.export16kMono(function(blob) {			
					
                    if ( _this.$socket.readyState == 1)
					{						
                        _this.$socket.send(blob);
                        // transfer char of end
                        let end = new Uint8Array(0);
                        _this.$socket.send(end);
                        _this.recorder.clear();
                    }
                }, 'audio/x-raw');
				this.recorder.clear();
            }
        },
        /*refreshRecorder() {
            this.stopRecording();
            this.startRecording();
        },
        runRecord() {
            this.startRecording();
            if (this.recordTask === null) {
                this.recordTask = setInterval(() => {
                    this.refreshRecorder()
                }, 4000);
            } else {
                this.clearRecordTask();
            }

        },
        clearRecordTask() {
            clearInterval(this.recordTask);
        },*/
        showDeviceList() {
            if (this.getUser != null && this.getUser.level == 9) {
                return 'block';
            } else {
                return 'none';
            }
        },
        musicPlay(voiceinput) {
            let music;
            music=document.getElementById(voiceinput);
            music.play();
        },
        clearStram() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
            }
        },
    },
    async mounted() { 
        await this.init(); //呼叫main.js與websocket server做連結(放在Kingcolon-master\client\src\main.js)
        const API_URL = process.env.VUE_APP_API_URL
        let frontEndLog;
        let url;
        const options = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        this.fetchVoiceCommandTestKeywordArray({
            keywordFile: this.keywordFile,
            examination_typeID: this.examination_typeID
        });

        const _this = this;
        
        //==========================================================================
        //※ Websocket Mode
        //==========================================================================
		//接收server端所傳送的訊息
        _this.$options.sockets.onmessage = function(data) {
		    //if (Number(this.openWebsocketMode) == 2)
			//{			
				var reader = new FileReader();
				reader.onload = function() {
				console.log(reader.result);
					data = JSON.parse(reader.result);
					console.log(data.data[0].text);
                    _this.setJudging(false);
					let params = JSON.stringify({
						frontEndLog: 'final # ' + frontEndLog + ' ' + data.data[0].text
					})
					url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
					_this.$http.post(url, params, options).then((response) => {
					//console.log(response);
					});
					_this.tempWebsocketResult[data.id] = data.data[0].text
					if (_this.tempWebsocketResult[data.id]) {
						// _this.speechRecognition("lipoma description soft size 1 antrum", 'websocket');
						_this.speechRecognition(_this.tempWebsocketResult[data.id], 'websocket');
						console.log(_this.tempWebsocketResult[data.id]);
						delete _this.tempWebsocketResult[data.id];
					}
				}
				reader.readAsText(data.data);			
            /*}
			else
			{
				if (data.status != 0 || !data.result || !data.result.final) return;
				_this.setJudging(false);
				// console.log('hypotheses # ' + data.id);
				//console.log(dataname);
				// console.log((new Date()).getTime().toString());
				frontEndLog=new Date().getTime().toString();
				console.log('final # ' + frontEndLog + ' ' + data.result.hypotheses[0].transcript);

				let params = JSON.stringify({
						frontEndLog: 'final # ' + frontEndLog + ' ' + data.result.hypotheses[0].transcript
					})
				url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
				this.$http.post(url, params, options).then((response) => {
					//console.log(response);
				});

				// console.log(data.result.hypotheses[0].transcript);
				_this.tempWebsocketResult[data.id] = data.result.hypotheses[0].transcript
				if (_this.tempWebsocketResult[data.id]) {
					// _this.speechRecognition("lipoma description soft size 1 antrum", 'websocket');
					_this.speechRecognition(_this.tempWebsocketResult[data.id], 'websocket');
					console.log(_this.tempWebsocketResult[data.id]);
					delete _this.tempWebsocketResult[data.id];
				}
            }*/
        }
		
		//開啟websocket
        _this.$options.sockets.onopen = function(e) {
			if (Number(this.openWebsocketMode) == 1)
			{
				// console.log('onopen #');
				_this.websocketOnOpenInterval = setInterval(function() {
					// console.log('send #');
					_this.recorder.export16kMono(function(blob) {
						// _this.$socket.send(blob);
						//if (!_this.recorder.status()) {
							// _this.recorder && _this.recorder.record();
							// console.log('Open Mic');
						//} else {
							if (_this.$socket) {
								var state = _this.$socket.readyState;
								if (state == 1) {
									// If item is an audio blob
									// console.log(blob.size);
									if (blob instanceof Blob) {
										if (blob.size > 0) {
											_this.$socket.send(blob);
											_this.recorder.clear();
											console.log('Send blob: ' + (new Date()).getTime().toString());
											console.log(blob);
											
											var reader = new FileReader();
											reader.onload = function(e) { 
												var rawData = reader.result;											
												frontEndLog=new Date().getTime().toString();
												let params = JSON.stringify({
													
													frontEndLog: 'Videodata: # ' + frontEndLog + ' ' + rawData
												})
												url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
												_this.$http.post(url, params, options).then((response) => {
													//console.log(response);
												});
											}
											reader.readAsDataURL(blob);// blob ->base64									
											
											// console.log('Send: blob: ' + blob.type + ', ' + blob.size);
										} else {
											// console.log('Send: blob: ' + blob.type + ', EMPTY');
										}
										// Otherwise it's the EOS tag (string)
									} else {
										_this.$socket.send(blob);
										_this.recorder.clear();
										// console.log('Send tag: ' + blob);
									}
								} else {
									// console.log('WebSocket: readyState!=1: ' + state + ': failed to send: ' + blob);
								}
							}
							// _this.recorder.clear();
						//}
					}, 'audio/x-raw'); //傳送的資料格式
				}, 250); // 250
			}
        }
        _this.$options.sockets.onclose = function(e) {
            // console.log('onclose # code: ' + e.code + ' || reason: ' + e.reason + ' || wasClean: ' + e.wasClean);
            // console.log(e);
            if (_this.recording) {
                clearInterval(_this.websocketOnOpenInterval);
                _this.$connect();
            } else {
                _this.stopRecording('1');
            }
        };
        _this.$options.sockets.onerror = function(e) {
            //console.log('onerror #');
            //console.log(e.data);
        };
    },
    destroyed () {
        this.isDestroyed = true
        this.clearStram()
        /*if (this.recordTask !== null) {
            this.clearRecordTask()
        }*/
        if (this.todoAutoInputInterval !== null) {
            clearInterval(this.todoAutoInputInterval);
        }
    },
}
</script>
<style lang="scss" scoped>
    table {
        td:nth-child(odd){
            padding: 3px; 
            border-radius: 5px; 
            background-color: #2894ff; 
            color: #fff; 
            font-size: 8px; 
            text-align: center;
        }
        td:nth-child(even){
            padding: 3px; 
            border-radius: 5px; 
            background-color: #E6E6E6;
        }
    }
    select, input  {
        width: 100%; 
        padding: 3px; 
        border-radius: 5px; 
        background-color: #fff; 
        font-size: 8px;
    }
    input {
        text-align: center;
    }
</style>
<style>
    /*#d {
        display: inline-block;
        max-height: 127.5px;
        background: #fff;
        max-width: 50px;
        z-index: 100000;
    }
    #d div {
        display: inline-block;
        width: 1px;
        background: #a00;
        margin: 0px 0px 0px 0.5px;
        padding: 0px;
        vertical-align: bottom;
    }*/
</style>